var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1015 2.21991C23.8086 1.92702 23.3338 1.92702 23.0409 2.21991L2.21967 23.0411C2.07901 23.1818 1.99999 23.3725 2 23.5715L2.00017 29.2498C2.00019 29.664 2.33595 29.9998 2.75015 29.9998L8.42849 30C8.62741 30 8.81818 29.9209 8.95884 29.7803L29.78 8.95908C29.9207 8.81843 29.9997 8.62767 29.9997 8.42875C29.9997 8.22984 29.9207 8.03908 29.78 7.89842L24.1015 2.21991ZM19.5751 7.807L23.5712 3.8109L28.1891 8.42875L24.193 12.4248L19.5751 7.807ZM18.5144 8.86766L3.50001 23.8821L3.50015 28.4998L8.11786 28.4999L23.1323 13.4855L18.5144 8.86766Z",
    fill: "#CCAD5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3480bed707276564237bb46255f1e1e0.svg";
export { ForwardRef as ReactComponent };